import { render, staticRenderFns } from "./AdminCrNotesReg.vue?vue&type=template&id=f20f1ca2"
import script from "./AdminCrNotesReg.vue?vue&type=script&lang=js"
export * from "./AdminCrNotesReg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports